import React, { useState } from "react";
import { TenantSwitcher } from "./tenant-switcher";
import { DebugPanel } from "./debug-panel";

export const DevTools: React.FC = () => {
  const [showDebugPanel, setShowDebugPanel] = useState(false);

  // Only show dev tools in development
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <>
      <TenantSwitcher
        onTenantChange={(tenantId) => {
          console.log(`🏢 Tenant switched to: ${tenantId}`);
        }}
      />
      <DebugPanel
        isVisible={showDebugPanel}
        onToggle={() => setShowDebugPanel(!showDebugPanel)}
      />
    </>
  );
};
